import { Button } from '@/components/ui/button';
import { Calendar as CalendarIcon, FileText } from 'lucide-react';

export type PostIdea = {
  title: string;
  idea?: string;
  digest?: string;
  content?: string;
  description?: string;
  format_template?: string;
  length_tag?: string;
  tone_style?: any;
  keywords?: string[];
  section_layout?: string[];
  element_settings?: Record<string, any>;
  content_type?: string;
};

export function ChatIdeaCard({ idea, onCreateOutline }: { idea: PostIdea; onCreateOutline?: (idea: PostIdea) => void }) {
  
  return (
    <div className="rounded-xl border border-brand-green-border bg-background p-4 shadow-sm hover:shadow-md transition-shadow h-full flex flex-col">
      <div className="flex-1">
        <h4 className="text-sm font-semibold text-foreground leading-tight">{idea.title}</h4>
        {(idea.idea || idea.content || idea.description || idea.digest) ? (
          <p className="mt-2 text-sm text-muted-foreground leading-relaxed">{idea.idea || idea.content || idea.description || idea.digest}</p>
        ) : null}
      </div>
      <div className="pt-3 mt-auto">
        {onCreateOutline && (
          <Button
            size="sm"
            variant="default"
            className="h-8 px-3 text-xs w-full bg-green-600 hover:bg-green-700 text-white"
            onClick={() => onCreateOutline(idea)}
          >
            Create outline
          </Button>
        )}
      </div>
    </div>
  );
}

export function IdeaCards({ ideas, onCreateOutline }: { ideas: PostIdea[]; onCreateOutline?: (idea: PostIdea) => void }) {
  return (
    <div className="grid grid-cols-1 sm:grid-cols-2 gap-3 w-full max-w-2xl">
      {ideas.map((idea, i) => (
        <ChatIdeaCard key={i} idea={idea} onCreateOutline={onCreateOutline} />
      ))}
    </div>
  );
}

export default IdeaCards;


